// ID branded (UUID opaque, không số tự tăng). Tạo ID chỉ qua các hàm dưới để kiểu không bị trộn lẫn.
declare const brand: unique symbol;
export type Brand<T, B extends string> = T & { readonly [brand]: B };

export type UserId = Brand<string, "UserId">;
export type WorkspaceId = Brand<string, "WorkspaceId">;
export type ProjectId = Brand<string, "ProjectId">;
export type OrgUnitId = Brand<string, "OrgUnitId">;
export type SessionId = Brand<string, "SessionId">;
export type RequestId = Brand<string, "RequestId">;

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isUuid(value: unknown): value is string {
  return typeof value === "string" && UUID.test(value);
}

function make<T extends string>(kind: string) {
  return (value: string): T => {
    if (!isUuid(value)) throw new TypeError(`${kind} không phải UUID: ${value}`);
    return value.toLowerCase() as T;
  };
}

export const UserId = make<UserId>("UserId");
export const WorkspaceId = make<WorkspaceId>("WorkspaceId");
export const ProjectId = make<ProjectId>("ProjectId");
export const OrgUnitId = make<OrgUnitId>("OrgUnitId");
export const SessionId = make<SessionId>("SessionId");
export const RequestId = make<RequestId>("RequestId");

export function newUuid(): string {
  return globalThis.crypto.randomUUID();
}
